import { useTheme } from '@emotion/react'
import { useEffect, useRef } from 'react'
import logo from '../images/logo-chat.svg'
import { serviceURLs } from '../../environment-config'
import { useMapi } from '../context/MapiProvider'

function setApiUrl(url) {
  window.chatApiUrl = url
}

function setTheme(colors) {
  window.chatTheme = {
    entryPointBackground: colors.primary.base.hex, // This is the color of the start chat button.
    brandColor1: colors.primary.base.hex,
    brandTextColor1: colors.primary.base.readable,
    brandColor2: colors.secondary.base.hex,
    brandTextColor2: colors.secondary.base.readable,
    linkColor: colors.primary.base.hex,
    primaryButtonColor: colors.primary.base.readable,
    primaryButtonBackground: colors.primary.base.hex,
    primaryButtonHoverBackground: colors.primary.dark.hex,
    buttonTextColor: colors.primary.base.readable,
    sendMsgColor: colors.success.base.hex,
    headerBackgroundColor: colors.primary.base.hex,
    trayBackground: colors.dark.light.hex,
    background: colors.light.lighter.hex,
    headerLogo: logo,
    entrypointLogo: logo,
  }
}

function useChat() {
  const initRef = useRef(false)
  const { colors } = useTheme()
  const { chatEnabled } = useMapi()

  useEffect(() => {
    const serverSide = typeof window === 'undefined'
    const cdnUrl = serviceURLs?.chatURL
    const apiUrl = serviceURLs?.chatApiURL

    let enabled = chatEnabled
    if (process.env.GATSBY_ENABLE_CHAT) {
      enabled = process.env.GATSBY_ENABLE_CHAT === 'true'
    }

    if (
      !enabled ||
      serverSide ||
      initRef.current ||
      !colors ||
      !apiUrl ||
      !cdnUrl
    ) {
      return () => {}
    }

    initRef.current = true
    setApiUrl(apiUrl)
    setTheme(colors)

    const s = document.createElement('script')
    s.src = cdnUrl
    s.async = true
    s.defer = true
    document.body.appendChild(s)

    return () => {
      document.body.removeChild(s)
    }
  }, [colors, chatEnabled, initRef])
}

export default useChat
